import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IMaintenanceState } from '../types';

export const fetchMaintenanceList = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchMaintenanceList`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.maintenance.getMaintenanceList();

      return response;
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Falló al cargar la lista de mantenimientos.');

      notificationService.global.error(errorMessage);

      return rejectWithValue(error);
    }
  },
);

export const fetchMaintenanceListReducer: TSliceExtraReducer<IMaintenanceState> = builder =>
  builder
    .addCase(fetchMaintenanceList.pending, state => {
      state.list.loading = true;
    })
    .addCase(fetchMaintenanceList.rejected, state => {
      state.list.loading = false;
      state.list.maintenances = [];
    })
    .addCase(fetchMaintenanceList.fulfilled, (state, action) => {
      state.list.loading = false;
      state.list.maintenances = action.payload;
    });
